<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th>Year</th>
                    <th>Qty</th>
                    <th v-if="selected == 'dealer'">Not Ready For Sales</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="prodYear in dataDisplayed">
                    <td>{{ prodYear.year }}</td>
                    <td>{{ numberWithCommas(prodYear.total) }}</td>
                    <td v-if="selected == 'dealer'">{{ numberWithCommas(prodYear.nrfs) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                dataDisplayed : [],
                dummyData : [],
            }
        },
        props : ['data', 'dealerData', 'selected'],
        mounted () {
            // this.generateDummyData();
            this.generateData();
        },
        watch : {
            selected () {
                this.generateData();
            }
        },
        methods : {
            generateData () {
                let data = []
                
                if (this.selected == 'maindealer')
                    data = this.data.map((x)=>{return{year:x.manufacture_year?x.manufacture_year:'No Year', total:x.total}})
                else if (this.selected == 'dealer')
                    data = this.dealerData.map((x)=>{return{year:x.tahun?x.tahun:'No Year', total:x.total, nrfs:x.nrfs}})

                //Add label no data when data is empty
                if (data.length == 0) data.push({year:'No Data', total:1})

                this.dataDisplayed = data;
            },
            generateDummyData () {
                let data = []
                for (var i = 2020; i > 1990; i--) {
                    data.push({
                        year : i,
                        qty : this.randomInt(1000, 20000)
                    })
                }
                this.dummyData = data;
            },
        }
    }
</script>

<style scoped>
    table tr th, table tr td {
        text-align: center;
    }

    table tr th {
        border-color: orange;
    }
</style>